import { NgModule } from '@angular/core';
import { ReachedEndDirective } from './reached-end-scroll.directive';

@NgModule({
  declarations: [ReachedEndDirective],
  exports: [ReachedEndDirective],
})
export class InfiniteScrollDirectivesModule {}
